import React from "react";
import {
  Content,
  ContentVariants,
  Level,
  LevelItem,
  Popover,
  Divider,
  Split, SplitItem
} from "@patternfly/react-core";

import CopyText from "shared/utils/CopyText";
import { getMediaUrl } from "../../../utils/media";
import { getMonths } from "shared/utils/monthsUtils";

export const SheetNameCell = ({ row, props, context, withMiniature = true, withPopover = true, isExpandedRow}) => {
  const sheetName = row?.name || "Brak nazwy";

  const miniature = row?.raw?.sheet_miniature;
  const sheetUrl = row?.raw?.sheet_url;
  
  const sheetUrlExists = Boolean(sheetUrl);
  const isPublic = row.raw?.visibility === "public";
  const isAuthVisible = 
    (row.raw?.visibility === "authenticated" && context.state.isAuthUser) || 
    (row.raw?.visibility === "restricted" && context.state.userProfile.is_superuser);

  // clickable tylko gdy URL istnieje i użytkownik ma dostęp
  const clickable = sheetUrlExists && (isPublic || isAuthVisible);

  const cursorStyle = clickable ? "pointer" : "default";
  const colorStyle = clickable ? undefined : "#6a6e73";
  const textDecorationStyle = clickable ? "underline" : "none";

  const miniatureUrl = miniature
  ? miniature.includes("/miniature/") // jeśli nowa struktura
    ? `${props.state.api_url}${miniature}`  // nowy URL
    : `${props.state.api_url}/${props.state.django_media_dir}/${miniature}` // stara struktura
  : null;
  
  const downloadUrl = sheetUrl
    ? sheetUrl.includes("/sheet/") // jeśli nowa struktura
      ? `${props.state.api_url}${sheetUrl}`  // nowy URL
      : `${props.state.api_url}/${props.state.django_media_dir}/${sheetUrl}` // stara struktura
    : null;

  const showMiniature = withMiniature && miniature;

  const handleDownload = (url, type) => {
    if (!url) return;
    const forceOpenInBrowser = type === "sheet";
    if (forceOpenInBrowser) {
      window.open(url, "_blank");
      return;
    }
    getMediaUrl(url, sheetName);
  };

  const sheetLink = (
    <Content
      component={ContentVariants.a}
      href={clickable ? downloadUrl : undefined}
      target={clickable ? "_blank" : undefined}
      rel={clickable ? "noopener noreferrer" : undefined}
      onClick={(event) => {
        event.stopPropagation();

        if (!clickable) {
          event.preventDefault();
        }
      }}
      style={{
        cursor: clickable ? "pointer" : "default",
        color: clickable ? undefined : "#6a6e73",
        // textDecoration: clickable ? "underline" : "none",
        // fontWeight: 600
      }}
    >
      {sheetName}
    </Content>
  );
  return (
    <Split>
      <SplitItem>
        {withPopover && !isExpandedRow ? (
          <Popover
            triggerAction="hover"
            aria-label="Szczegóły arkusza"
            bodyContent={
              <div>
                <Level>
                  <LevelItem>
                    <b>Nr:</b>{" "}
                    {row.raw?.task_number?.toString().padStart(2, "0")}
                  </LevelItem>

                  <LevelItem>
                    <b>Sesja:</b> {getMonths(row.exam_month)}
                  </LevelItem>
                </Level>

                <Divider />

                {showMiniature && (
                  <>
                    <br />
                    <img
                      src={miniatureUrl}
                      alt={sheetName}
                      style={{ maxWidth: "200px" }}
                    />
                  </>
                )}
              </div>
            }
          >
            {sheetLink}
          </Popover>
        ) : (
          sheetLink
        )}
      </SplitItem>
      <SplitItem>
        <CopyText
          text={sheetName}
          id={row.id}
          style={{ marginLeft: "10px" }}
        />
      </SplitItem>
    </Split>
  );
};